import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService, FormService } from 'src/app/services';

@Component({
	selector: 'app-forgot-my-password',
	templateUrl: './forgot-password.component.html',
	styleUrls: ['./forgot-password.component.css'],
})
export class ForgotPasswordComponent implements OnInit {
	public isLoading = false;

	public forgotPasswordForm = new FormGroup({
		email: new FormControl('', [Validators.required, Validators.email]),
	});

	forgotPasswordErrorMessages = {
		email: [
			{ type: 'required', message: 'Email is required' },
			{ type: 'email', message: 'Enter a valid email' },
		],
	};

	constructor(
		public authService: AuthService,
		public formService: FormService,
	) {
		// block
	}

	public ngOnInit(): void {
		// block
	}

	public resetPassword(email: any) {
		this.authService.resetPassword(email.value);
	}

	public onSubmit(forgotPasswordForm: any) {
		this.formService.markFormGroupTouched(this.forgotPasswordForm);
		if (!this.isLoading) {
			this.isLoading = true;

			if (forgotPasswordForm.status !== 'VALID') {
				this.isLoading = false;
				this.authService.addToastMsg('Please fill missing detail.');
				return;
			}
			this.authService
				.resetPassword(forgotPasswordForm.value.email)
				.catch(e => {
					this.isLoading = false;
				});
		}
	}
}
